import { useEffect, useRef } from 'react';
import type { RefObject } from 'react';

const NEAR_BOTTOM_PX = 40;

export function useAutoScroll(
  scrollRef: RefObject<HTMLElement | null>,
  isStreaming: boolean,
) {
  const isAtBottom = useRef(true);

  useEffect(() => {
    const element = scrollRef.current;
    if (!element) {
      return;
    }
    const onScroll = () => {
      isAtBottom.current =
        element.scrollHeight - element.scrollTop - element.clientHeight <
        NEAR_BOTTOM_PX;
    };
    element.addEventListener('scroll', onScroll);
    return () => element.removeEventListener('scroll', onScroll);
  }, [scrollRef]);

  useEffect(() => {
    if (isStreaming) {
      isAtBottom.current = true;
    }
  }, [isStreaming]);

  useEffect(() => {
    const element = scrollRef.current;
    if (element && isAtBottom.current) {
      element.scrollTop = element.scrollHeight;
    }
  });
}
